import AdminProducts from "./AdminProducts";

/**
 * Product Management → Products.
 * The unified platform-owner product list: the full-featured AdminProducts page
 * broadened to also surface Funeral channel products, with a per-row channel
 * availability popup. All product features (tabbed CRUD, override prices,
 * variants, add-ons, collections, images, customizations) come from AdminProducts
 * unchanged — only the channel scope + channel popup are enabled here.
 */
export default function ProductManagementProducts() {
  return <AdminProducts includeFuneralChannel enableChannelColumn />;
}
